import { isAnalyticsEnabled } from '../core';
import { ChurnZeroCustomerData, SonarChurnZeroWindow } from './@types';

declare const window: SonarChurnZeroWindow;

function isChurnZeroAnalyticsEnabled(): boolean {
	const { churn_zero_app_key } = window.sonar;

	// eslint-disable-next-line camelcase
	return Boolean(churn_zero_app_key) && isAnalyticsEnabled();
}

export function initializeChurnZero(data: ChurnZeroCustomerData): void {
	if (isChurnZeroAnalyticsEnabled()) {
		const cz = window.ChurnZero || [];

		cz.push([ 'setAppKey', window.sonar.churn_zero_app_key ]);
		cz.push([ 'setContact', data.externalAccountId, data.externalContactId ]);
		cz.push([ 'trackEvent', 'Login' ]);
	}
}
